import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-eprove-links',
  templateUrl: './footer-eprove-links.component.html',
  styleUrls: ['./footer-eprove-links.component.scss']
})

export class FooterEproveLinksComponent { }
